module.exports = "p {\r\n    margin-bottom: 0;\r\n    font-size: 0.875rem;\r\n    line-height: 0px;\r\n}\r\n\r\n.input-group-append {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/search-country/search-country.component.css
// module id = ./src/app/shared/components/search-country/search-country.component.css
// module chunks = main